module.exports = __webpack_public_path__ + "static/img/imagem-informes-ipaam.3810ac91.png";